<template>
  <div class="house-info">
    <div class="page-title">基础信息</div>
    <a-row type="flex" :gutter="[16, 16]">
      <a-col :span="24" :xl="8">
        <p>房屋信息：{{info.full_name}}</p>
      </a-col>
      <a-col :span="24" :xl="8">
        <p>房屋户型：{{info.housing_type.name}}</p>
      </a-col>
      <a-col :span="24" :xl="8">
        <p>房屋属性：{{info.houseTypeText}}</p>
      </a-col>
      <a-col :span="24" :xl="8">
        <p>房屋状态：{{info.houseStatusText}}</p>
      </a-col>
      <!-- <a-col :span="24" :xl="8">
        <p>入住时间：10000</p>
      </a-col> -->
    </a-row>
    <div class="page-title">住户信息</div>
    <a-table :loading="tableOne.loading" :columns="tableOne.columns" :data-source="tableOne.data" rowKey="mobile" :pagination="false"></a-table>
    <div class="page-title">车位信息</div>
    <a-table :loading="tableTwo.loading" :columns="tableTwo.columns" :data-source="tableTwo.data" rowKey="created_at" :pagination="false"></a-table>
  </div>
</template>

<script>
  import {
    houseTypeText,
    houseStatusText,
    parkingStatusText
  } from '@/io/dict.js';
  import BuildingService from '@/io/building.js';

  export default {
    name: 'HouseInfo',
    props: {
      id: {
        type: Number,
        default: null
      },
    },
    data() {
      return {
        info: {
          housing_type: {}
        },
        tableOne: {
          loading: false,
          data: [],
          columns: [
            {
              title: '姓名',
              dataIndex: 'name'
            },
            {
              title: '房屋身份',
              dataIndex: 'identity.name'
            },
            {
              title: '手机号',
              dataIndex: 'mobile'
            },
            // {
            //   title: '入住时间',
            //   dataIndex: 'building_count'
            // },
          ]
        },
        tableTwo: {
          loading: false,
          data: [],
          columns: [
            {
              title: '车位信息',
              dataIndex: 'carport_info'
            },
            {
              title: '车位状态',
              dataIndex: 'parkingStatusText'
            },
            {
              title: '登记时间',
              dataIndex: 'created_at'
            }
          ]
        }
      }
    },
    watch: {
      id: {
        handler(newValue, oldValue) {
          if (newValue) {
            this.initHouseInfo();
            this.initResidentInfo();
            this.initParkingInfo();
          }
        },
        immediate: true
      }
    },
    methods: {
      initHouseInfo() {
        BuildingService.houseInfo(this.id).then(res => {
          this.info = {
            ...res,
            housing_type: res.housing_type || {},
            houseTypeText: houseTypeText(res.house_state),
            houseStatusText: houseStatusText(res.state)
          };
        }).catch(err => {});
      },
      initResidentInfo() {
        this.tableOne.loading = true;
        BuildingService.houseResidentInfo(this.id).then(res => {
          this.tableOne.data = res;
        }).catch(err => {}).finally(() => {
          this.tableOne.loading = false;
        });
      },
      initParkingInfo() {
        this.tableTwo.loading = true;
        BuildingService.houseParkingInfo(this.id).then(res => {
          this.tableTwo.data = res.map(val => {
            val.parkingStatusText = parkingStatusText(val.sale_state);
            return val;
          });
        }).catch(err => {}).finally(() => {
          this.tableTwo.loading = false;
        });
      }
    },
  }
</script>

<style lang="less" scoped>

</style>